module.exports = __webpack_public_path__ + "static/js/0.e3a2b99d.chunk.worker.js"